export const idFromSlug = (slug: string): string => {
  const id = slug.split("-").pop() as string;
  const validId = /^[0-9]+$/.test(id);
  return validId ? id : "";
};
